var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container",style:(_vm.gridStyle)},_vm._l((9),function(n){return _c('div',{key:n,staticClass:"grid-item",class:{ center: n === 5 },on:{"click":function($event){return _vm.$emit('item-click', n)}}},[_vm._t([
          'itemA',
          'top',
          'itemB',
          'left',
          'center',
          'right',
          'itemC',
          'bottom',
          'itemD',
        ][n - 1])],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }